/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Promotion } from './Promotion';
// @ts-ignore
import {
// @ts-ignore
    PromotionFromJSON,
// @ts-ignore
    PromotionFromJSONTyped,
// @ts-ignore
    PromotionToJSON,
} from './Promotion';

/**
 * 
 * @export
 * @interface PromotionListResponse
 */
export interface PromotionListResponse {
    /**
     * 
     * @type {number}
     * @memberof PromotionListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PromotionListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<Promotion>}
     * @memberof PromotionListResponse
     */
    items: Array<Promotion>;
}

/**
 * Check if a given object implements the PromotionListResponse interface.
 */
// @ts-ignore
export function instanceOfPromotionListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function PromotionListResponseFromJSON(json: any): PromotionListResponse {
    return PromotionListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function PromotionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(PromotionFromJSON)),
    };
}

// @ts-ignore
export function PromotionListResponseToJSON(value?: PromotionListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(PromotionToJSON)),
    };
}

